<template>
    <div class="card border-primary border-darken-1">
        <div class="card-body">
            <div class="row">
                <h5 class="card-title text-primary mx-auto">
                    Client Billing
                </h5>
            </div>
            <div class="row">
                <a href="https://app.recurly.com/signup " target="_blank" class="btn-sm btn-primary mx-auto mb-1">
                    <vue-feather type="external-link" size="12"></vue-feather>
                    <span>
                        Signup
                    </span>
                </a>
            </div>
            <div class="row mx-auto">
                <div class="col-md-6 col-lg-6 col-sm-12">
                    <div class="form-group">
                        <div class="controls">
                            <label class="label-green" for="recurly-api-key">
                                API Key
                            </label>
                            <input
                                type="text"
                                class="form-control"
                                required
                                placeholder="API Key"
                                id="recurly-api-key"
                                name="recurly-api-key"
                                v-model="businessStore.business.recurly.api_key"
                            />
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-6 col-sm-12">
                    <div class="form-group">
                        <div class="controls">
                            <label class="label-green" for="webhook-url">
                                Webhook URL
                            </label>
                            <div class="input-group">
                                <input
                                    type="text"
                                    class="form-control"
                                    required
                                    placeholder="Webhook URL"
                                    id="webhook-url"
                                    name="webhook-url"
                                    :value="businessStore.business.recurly.webhook_url"
                                    readonly
                                />
                                <div class="input-group-append">
                                    <button
                                        class="btn btn-outline-primary recurly-copy"
                                        data-clipboard-target="#webhook-url"
                                        type="button"
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        title="Copy to clipboard"
                                    >
                                        <vue-feather size="12" type="copy" />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-6 col-sm-12">
                    <div class="form-group">
                        <div class="controls">
                            <label class="label-green" for="webhook-secret-key">
                                Webhook Secret Key
                            </label>
                            <input
                                type="text"
                                class="form-control"
                                required
                                placeholder="Webhook Secret Key"
                                id="webhook-secret-key"
                                name="webhook-secret-key"
                                v-model="businessStore.business.recurly.webhook_secret_key"
                            />
                        </div>
                    </div>
                </div>
                <div class="col-md-12 col-lg-12 col-sm-12">
                    <button
                        type="button"
                        class="btn btn-primary mr-2"
                        @click="businessStore.saveSettings"
                    >
                        {{ localizationStore.translate('save.changes') }}
                    </button>
                    <button
                        type="button"
                        data-dismiss="modal"
                        class="btn btn-outline-secondary mr-2"
                    >
                        {{ localizationStore.translate('close') }}
                    </button>
                    <button
                        type="button"
                        data-toggle="modal"
                        data-target="#recurly-client-billing-tutorial-modal-video"
                        class="btn btn-outline-primary"
                    >
                        <vue-feather size="12" type="film" />
                        Tutorial
                    </button>
                </div>
            </div>
        </div>
    </div>
    <video-player-component
        element_id="recurly-client-billing-tutorial-modal-video"
        title="Creditfixrr Client Billing Tutorial"
        :source="businessStore.tutorials.recurly"
    />
</template>
<script>
import { ref, reactive } from 'vue'
import { useUserStore } from '../../../../../stores/UserStore.js'
import { useBusinessStore } from '../../../../../stores/BusinessStore.js'
import { useLocalizationStore } from '../../../../../stores/LocalizationStore.js'
import VideoPlayerComponent from '../../../tutorials/VideoPlayerComponent.vue'
import axios from 'axios'
import Clipboard from 'clipboard';
export default{
    components:{
        VideoPlayerComponent
    },
    setup() {
        return {
            userStore: useUserStore(),
            businessStore: useBusinessStore(),
            localizationStore: useLocalizationStore(),
        }
    },
    watch: {
    },
    mounted() {
        new Clipboard('.recurly-copy');
    },
    methods:{
    }
}
</script>
